// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"62c33f91","105":"ff43f97f","122":"e1759a3c","473":"33581f9d","486":"fdc22035","618":"fd23e12e","721":"e3ebc163","809":"ee6ca930","880":"629c1c43"}[chunkId] + ".chunk.js";
};